"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoResultsMessage = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _react = _interopRequireDefault(require("react"));
var _i18n = require("../../../../i18n/i18n");
var _selectV2Theme = require("../selectV2Theme");
var _OptionBaseStyled = require("./OptionBaseStyled");
const NoResultsMessageStyled = (0, _styled.default)(_OptionBaseStyled.OptionBaseStyled)`
    color: ${(0, _designTokensReact.color)("color--text--neutral--weak")};
    pointer-events: none;
    text-align: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _selectV2Theme.selectV2Theme.option.noResults.textAlign(themeMode);
}};
    font-size: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _selectV2Theme.selectV2Theme.option.noResults.fontSize(themeMode);
}};
`;
const NoResultsMessage = props => {
  const {
    i18n
  } = (0, _i18n.useI18n)();
  return /*#__PURE__*/_react.default.createElement(NoResultsMessageStyled, props, i18n._( /*i18n*/{
    comment: "Displayed when there are no results to show, either due to lack of data, or lack of matching after a search.",
    id: "No results found."
  }));
};
exports.NoResultsMessage = NoResultsMessage;
//# sourceMappingURL=NoResultsMessage.js.map